var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBriefcaseMetal = function SvgIconBriefcaseMetal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.75 2a2.5 2.5 0 0 0-2.5 2.5v1.25h-3.5A1.75 1.75 0 0 0 2 7.5v12c0 .966.784 1.75 1.75 1.75h16.5A1.75 1.75 0 0 0 22 19.5v-12a1.75 1.75 0 0 0-1.75-1.75h-3.5V4.5a2.5 2.5 0 0 0-2.5-2.5zm5 3.75V4.5a.5.5 0 0 0-.5-.5h-4.5a.5.5 0 0 0-.5.5v1.25zM4 15.5v-4h16v4zm16-6H4V7.75h16zm0 8v1.75H4V17.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBriefcaseMetal;